/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetBreadcrumbsRequest, TGetBreadcrumbsModel, IMappers, TGetBreadcrumbsResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetBreadcrumbsV1Response } from '../../entities/breadcrumbs/GetBreadcrumbsV1Response';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetBreadcrumbsModel(parameters: IGetBreadcrumbsRequest): TGetBreadcrumbsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'seo-sections',
    pathApi: '/v1/get-breadcrumbs/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetBreadcrumbsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetBreadcrumbsRequest;
}

export async function fetchGetBreadcrumbs<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetBreadcrumbsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetBreadcrumbsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetBreadcrumbsModel(parameters),
    config,
  )) as FetchResponse<TGetBreadcrumbsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetBreadcrumbsV1Response, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetBreadcrumbsResponse>;
}
